export enum PrincipleTypesenseCollection {
  Patients = 'patients',
  Tasks = 'tasks',
  WaitLists = 'waitLists',
}
